import { configureStore } from '@reduxjs/toolkit';
import dataReducer from "../slices/dataSlice";
import { loadState, saveState } from "./localStorage";

const preloadedState = {
  data: loadState()
};

const store = configureStore({
  reducer: {
    data: dataReducer,
  },
  preloadedState,
});

// Persist on every change
store.subscribe(() => { saveState(store.getState().data); });

export default store;